import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';

import Actions from '../action';
import { appConstant, apiUrl, notificationStrings } from '@constants';
import { getAuthToken, getAuthKey, getKeyAndToken } from '@helpers';
import { openNotificationWithIcon } from '@sharedComponent/notification-message/notification';
import ActionsApp from '@sharedComponent/app-action-reducer/action';

export function* getCampaignListWorker({ companyId, history }) {
	const { authKey, authToken } = getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.GET_CAMPAIGN_DD}${companyId}`;
		const res = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.getCampaignDropdownSuccess(res.data.messages));
	} catch (err) {
		message.error(appConstant.somethingWentWrong);
		// if (authKey) yield put(ActionsApp.creators.removeUser(authKey, history));
		yield put(Actions.creators.getCampaignDropdownFail());
	}
}

export function* addAffiliateWorker(action) {
	try {
		const authKey = yield getAuthKey();
		const uri = `${appConstant.domain + apiUrl.ADD_AFFILIATE + authKey}`;
		const authToken = yield getAuthToken();
		const res = yield call(Axios.post, uri, action.affiliate, { headers: { Authorization: authToken } });
		if (res.data.success) {
			yield put(Actions.creators.addAffiliateSuccess());
			openNotificationWithIcon(notificationStrings.success, 'Invitation Sent', 'Please verify the your account by clicking the mail');
		} else {
			yield put(Actions.creators.addAffiliateFail());
			openNotificationWithIcon(notificationStrings.error, 'Failed', res.data.messages[0]);
		}
	} catch (err) {
		let mes = err.toString(err) === 'Error: Request failed with status code 400' ? appConstant.userNotExist : 'Something went wrong';
		message.error(mes);
		yield put(Actions.creators.addAffiliateFail());
	}
}

export default function* addAffiliateWatcher() {
	yield takeEvery(Actions.types.ADD_AFFILIATE_STARTED, addAffiliateWorker);
	yield takeEvery(Actions.types.GET_CAMPAIGN_DD_STARTED, getCampaignListWorker);
}
